import { render } from "./EditLocationShelfModal.vue?vue&type=template&id=3d53ed40"
import script from "./EditLocationShelfModal.vue?vue&type=script&lang=js"
export * from "./EditLocationShelfModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__